import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { BackgroundSurfaceType } from '@design-system/components/atoms/background-surface/entities/background-surface.types';

@Component({
  selector: 'app-fixed-surface',
  styleUrls: ['./fixed-surface.component.sass'],
  templateUrl: './fixed-surface.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FixedSurfaceComponent {

  @Input() boxShadow = false;
  @Input() surface = BackgroundSurfaceType.Primary;

  constructor() { }

}
